module.exports = __webpack_public_path__ + "img/2.4e14ae5f.jpeg";